// src/components/EnvironmentBadge.js
import React from 'react';
import PropTypes from 'prop-types';
import './EnvironmentBadge.css'; // Assuming you have some CSS for styling

const EnvironmentBadge = ({ className = '' }) => {
  // Get environment from process.env
  const environment = process.env.NODE_ENV;
  const customEnv = process.env.REACT_APP_ENVIRONMENT;
  
  // Use custom env if available, otherwise fall back to NODE_ENV
  const currentEnv = customEnv || environment;
  
  // Don't show badge in production
  if (currentEnv === 'production') {
    return null;
  }
  
  // Define environment-specific styling and text
  const getEnvironmentConfig = () => {
    switch (currentEnv) {
      case 'development':
        return {
          text: 'DEV',
          className: 'env-badge dev'
        };
      case 'test':
        return {
          text: 'Test',
          className: 'env-badge staging'
        };
      case 'staging':
        return {
          text: 'STAGING',
          className: 'env-badge staging'
        };
      default:
        return {
          text: currentEnv.substring(0, 3).toUpperCase(),
          className: 'env-badge default'
        };
    }
  };
  
  const config = getEnvironmentConfig();
  
  return (
    <span className={`${config.className} ${className}`}>
      {config.text}
    </span>
  );
};

EnvironmentBadge.propTypes = {
  className: PropTypes.string
};

EnvironmentBadge.defaultProps = {
  className: ''
};

export default EnvironmentBadge;